const TMP_URL = `${process.env.REACT_APP_TMP_ORIGIN_URL}/common/country`

const TmpCountryApiUrls = {

    //Country
    GET: `${TMP_URL}/get`,
    CREATE: `${TMP_URL}/create`,
    EDIT: `${TMP_URL}/update`,
    LIST: `${TMP_URL}/get`,
    DELETE: `${TMP_URL}/delete`,
}

export default TmpCountryApiUrls